import React, {Component} from 'react';
import AUX from '../../hoc/Aux_';
import MUIDataTable from "mui-datatables";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import BorderColorTwoToneIcon from '@material-ui/icons/BorderColorTwoTone';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { Alert, AlertTitle } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';

import Dialog from '@material-ui/core/Dialog';
import DialogDetail from '../../components/Kugi/dialogdetail';

import EditCms from './EditCms';
import AddCms from './AddCms';

import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link } from 'react-router-dom';

import { fetchCms, deleteCms} from '../../api/cms';
import { generateRDFAll, generateRDFCatalogOnly, generateRDFloop, generateRDFloopx } from '../../api/featurecatalog';
import {pushSelectedCategory} from '../../actions/general';
import { connect } from 'react-redux';

class Cms extends Component{

  constructor(props) {
    super(props);
    this.state = {
      selected: "faq",
      fetchType : [],
      category: [],
      cmsData: [],
      open : false,
      fcid: 1,
      featureCatalog: [],
      action: "add",
      code: "",
      dataSelected: []
    }
  }

  componentWillMount(){
    if(localStorage.getItem('token')==null){
      console.log(localStorage.getItem('token'));
      this.props.history.push(`/login`);
    }

    fetchCms(this.state.selected)
      .then(response => {
        this.setState({cmsData:response.data});
      })
      .catch(error => {
        console.log(error);
      });

  }

  handleDelete = (e) => {

    let dictioanryId = this.state.cmsData[e.data[0].index].cmsId;


    deleteCms(dictioanryId)
      .then(response => {
        console.log("deleted");
        this.handleReload();
      })
      .catch(error => {
        console.log(error);
      });
  }

  handleChange = (e)=>{

    this.setState({selected:e.target.value, categorySelected: e.target.value });
    this.props.pushSelectedCategory(e.target.value);

    fetchCms(e.target.value)
      .then(response => {
        this.setState({cmsData:response.data});
      })
      .catch(error => {
        console.log(error);
      });

  }

  handleClose = () =>{
    this.setState({open:false});
  }

  renderMenu = (e)=>{
    return (<MenuItem value={e.featureCatalogId.replace("@en", "")}>{e.name.replace("@en", "")}</MenuItem>)
  }

  handleUpdate = (e)=>{
    console.log(e);
    this.setState({open:true, action:"edit",dataSelected:e});
  }

  handleReload = (e)=>{

    fetchCms(this.state.selected)
      .then(response => {
        this.setState({cmsData:response.data});
      })
      .catch(error => {
        console.log(error);
      });
  }

  renderAddEdit = ()=>{
    if(this.state.action == "edit"){
      return (
        <EditCms handleOpen = {this.handleClose} typenya = {this.state.selected} cmsData = {this.state.cmsData} dataSelected={this.state.dataSelected} handleReload = {this.handleReload}/>
      )
    }else{
      return (
        <AddCms handleOpen = {this.handleClose} typenya = {this.state.selected} handleReload = {this.handleReload}/>
      )
    }

  }


  render(){

    const options = {
      filterType: 'checkbox',
      onRowsDelete: this.handleDelete
    };

    const columns = [
      {
        name:"cmsId",
        label: "Update",
        options: {
         filter: true,
         sort: false,
         customBodyRender: (value, tableMeta, updateValue) => (
           <BorderColorTwoToneIcon color="primary" onClick={event => this.handleUpdate(value)} style = {{cursor:"pointer"}}/>
         )
        }
      },
      {name:"title"},
      {name:"description"},
      {name:"type"}
    ];

    return (
      <AUX>
      <Dialog
        open={this.state.open}
        fullScreen
        maxWidth={""}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle disableTypography style = {{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
        >
          <span/>
            <IconButton onClick={this.handleClose}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
           {this.renderAddEdit()}
        </DialogContent>
      </Dialog>

      <section className="sections" style = {{paddingTop:"5%"}}>

      <div className="row justify-content-center" >

      <FormControl variant="outlined" style = {{minWidth: 250}}>
        <InputLabel id="demo-simple-select-label">Choose CMS Type</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={this.state.selected}
          onChange={this.handleChange}
        >
          <MenuItem value={"faq"}>FAQ</MenuItem>
          <MenuItem value={"header"}>Deskripsi Web</MenuItem>
          <MenuItem value={"fiturtitle"}>Judul Fitur</MenuItem>
          <MenuItem value={"fitur"}>Fitur</MenuItem>
          <MenuItem value={"kontak"}>Kontak</MenuItem>
          <MenuItem value={"tentang"}>Tentang</MenuItem>
        </Select>
      </FormControl>
      </div>
        <div className="container">

          <Button variant="contained" color="primary" onClick = {()=>{this.setState({open:true, action: "add"})}}>Tambah CMS </Button>

          <MUIDataTable
          data={this.state.cmsData}
          columns={columns}
          options={options}
          />
          <div className="container">
              <div className="row justify-content-center" id="counter"/>
          </div>
        </div>
      </section>
      </AUX>
    )
  }
}

const mapStatetoProps = state => {

    return {
        categorySelected: state.categorySelected
    };
}


export default connect(mapStatetoProps, {pushSelectedCategory})(Cms);
